import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const MENU_WIDTH = 300;

export const useStyles = makeStyles(({ spacing, palette }: Theme) => ({
  container: {
    display: 'flex',
    padding: `0 ${spacing(3)}`,
    maxWidth: '590px',
  },

  menuSearch: {
    padding: spacing(2),
    display: 'flex',
    flexDirection: 'column',
  },

  info: {
    display: 'flex',
    flexDirection: 'column',
    padding: `0 ${spacing(2)}`,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    '& div': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },

  condominiumName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  menuItem: {
    display: 'flex',
    alignItems: 'center',
    padding: `${spacing(2)} !important`,
    gap: spacing(2),
    width: `${MENU_WIDTH}px`,
  },

  menuContent: {
    width: `${MENU_WIDTH}px`,
    '& .MuiMenu-list': {
      background: palette.neutral[300],
      display: 'flex',
      maxHeight: '400px',
    },
    '& .simplebar-content': {
      height: 'auto',
      display: 'flex',
    },
  },

  menuInfo: {
    position: 'sticky',
    top: '0',
    background: palette.neutral[300],
    zIndex: 999,
  },

  menuGoTo: {
    padding: spacing(2),
    fontSize: '0.875rem',
  },

  title: {
    color: palette.secondary.main,
    fontSize: '0.875rem',
  },
}));

export default useStyles;
